import React from "react"
import { Field } from "formik"

const Checkbox = ({ name, label, className, children, ...props }) => (
	<div className={`w-full  ${className || ""}`}>
		<div className="w-full flex items-center col-span-2 group">
			<Field
				type="checkbox"
				id={name}
				name={name}
				className="self-start mt-1 group-hover:cursor-pointer w-[26px] h-[26px] rounded-[6px] border-2 default:border-jetblack checked:border-transparent group-hover:border-pictonblue group-hover:checked:border-tealblue text-tealblue focus:ring-transparent"
				{...props}
			/>
			{label && (
				<label
					htmlFor={name}
					className="group-hover:cursor-pointer ml-10 block text-base text-nevada group-hover:text-pictonblue">
					{label}
				</label>
			)}
			{children && <div className="ml-10 block text-base text-nevada">{children}</div>}
		</div>
	</div>
)

export default Checkbox
